
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stod-och-verktyg",
      function () {
        return require("private-next-pages/stod-och-verktyg/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stod-och-verktyg"])
      });
    }
  